import {
  Button,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Box,
  Text,
  useToast,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { DASHBOARD_URL } from "utils/constants";
import AuthBox from "components/elements/AuthBox";
import { AuthHeading } from "components/layout/AuthLayout";
import { getErrorMessage } from "utils/errorHandler";
import { useAuth } from "modules/authentication/providers/authentication-provider";
import { useAuthenticationActions } from "modules/authentication/mutations/authentication-actions";

export function Reset() {
  const { company } = useAuth();
  const toast = useToast();
  const [email, setEmail] = useState("");
  const { resetPassword } = useAuthenticationActions();

  const handleResetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault();

      await resetPassword.mutateAsync({
        email,
        redirectTo: `${DASHBOARD_URL}/update`,
      });

      toast({
        title: "Email Sent!",
        description: "Please check your email with a link to reset your password.",
      });

      setEmail("");
    } catch (err) {
      toast({
        title: "Request Failed",
        description: getErrorMessage(err),
        status: "error",
      });
    }
  };

  useEffect(() => {
    window.analytics.page("Reset Password");
  }, []);

  return (
    <AuthBox>
      <AuthHeading title="Reset Password" />
      <Box w="370px">
        <form onSubmit={handleResetPassword}>
          <FormControl mt="16px">
            <FormLabel variant="onboarding">Email Address</FormLabel>
            <Input
              type="email"
              placeholder="john@company.com"
              value={email}
              onChange={ev => setEmail(ev.target.value)}
              variant="primary"
            />
          </FormControl>
          <VStack>
            <Button
              isLoading={resetPassword.isPending}
              colorScheme="blue"
              type="submit"
              mt="24px"
              mb="20px"
              px="36px"
            >
              Send Reset Email
            </Button>
            <Text fontSize="16px">
              Have an account?{" "}
              <Link to={company ? `/login/${company.slug}` : "/login"} color="primary">
                Log In
              </Link>
            </Text>
          </VStack>
        </form>
      </Box>
    </AuthBox>
  );
}
